/* eslint-disable react/no-direct-mutation-state */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import gtm from 'general/js/gtm';
import * as signInFormActions from '../../../store/actions/sign-in-form-actions';
import * as signInFormHelpers from '../helpers/form-helpers/sign-in-form-helpers';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import * as upgradeAccountFormActions from '../../../store/actions/upgrade-account-actions';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import { isEmpty } from '../../utils/obj-utils';
import initialState from '../helpers/form-helpers/initial-state';
import FormBuilder from '../helpers/form-builder';
import SSOFormHeader from '../../common/utility/SSOFormHeader';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import userService from '../../../../../general/js/user/user-service';
import { SECUTIX_CONTACT_ID, USER_ID } from '../../../../../general/js/user/constants';
import { hasValue, isNullOrUndefined } from '../../../../../general/js/general-helpers';
import { toggleBemClassesForSSOFormModal } from '../helpers/form-helpers/form-modal-helpers';
import * as upgradeFormHelper from '../helpers/form-helpers/upgrade-form-helper';
import { ssoFormTypes } from '../../utils/form-types';
import { getWebsiteDomain } from '../../../../../general/js/helpers';
import { domainConstants } from '../../utils/constants/domain-constants';
import {
    MembershipTypes,
    getParameterByName,
    redirectTo,
    reloadPage,
    reloadToBasePage
} from '../../../../../general/js/utils';
import { QueryConstants } from '../../../../../general/js/utils/query-constants';
import { CookieNames } from '../../../../../general/js/utils/cookies';

class SignInForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState.signInFormState,
            isModalStylingUpdated: false,
            gtmTrigger: false
        };

        this.formReference = React.createRef();
        this.displaySignInForm = this.displaySignInForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.submitSignInData = this.submitSignInData.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.handleSignInSuccess = this.handleSignInSuccess.bind(this);
        this.updateLastLogInUserDetails = this.updateLastLogInUserDetails.bind(this);
        this.loadSignInFormData = this.loadSignInFormData.bind(this);
        this.getNextComponentToRender = this.getNextComponentToRender.bind(this);
        this.loadSSOSignInSuccessFormData = this.loadSSOSignInSuccessFormData.bind(this);
        this.loadSSOUpgradeToOneClubFormData = this.loadSSOUpgradeToOneClubFormData.bind(this);

        this.loadSignInFormData();
        this.loadSSOSignInSuccessFormData();
    }

    loadSignInFormData() {
        const { actions, signInFormData } = this.props;

        if (isEmpty(signInFormData)) {
            actions.loadSSOSignInFormData();
        }
    }

    loadSSOSignInSuccessFormData() {
        const { actions } = this.props;

        actions.loadSSOSignInSuccessFormData();
    }

    componentDidMount() {
        this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, this.props, ssoFormTypes.SignIn);
    }

    loadSSOUpgradeToOneClubFormData() {
        const { actions } = this.props;

        actions.loadSSOUpgradeToOneClubFormData();
    }

    componentWillReceiveProps(nextProps) {
        const {
            isSignInSuccessful,
            isNewPasswordRequired,
            cognitoUser,
            onNewPasswordRequired,
            loading,
            isUserLastLogInDataUpdated,
            userLastLogInDataErrorMessages,
            signInFormData
        } = nextProps;

        if (hasValue(signInFormData) && !this.state.isModalStylingUpdated) {
            this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, nextProps, ssoFormTypes.SignIn);
        }

        if (signInFormHelpers.isSignInSuccess(nextProps) && !(isUserLastLogInDataUpdated || hasValue(userLastLogInDataErrorMessages))) {
            this.updateLastLogInUserDetails(nextProps);
        }

        if (signInFormHelpers.isSignInSuccess(nextProps) && (isUserLastLogInDataUpdated || hasValue(userLastLogInDataErrorMessages))) {
            this.handleSignInSuccess(cognitoUser, nextProps);
        }

        if (!loading && isNewPasswordRequired && isSignInSuccessful) {
            onNewPasswordRequired(cognitoUser);
        }

        if (!loading && !isSignInSuccessful) {
            this.setState(formStateHelpers.updateProcessingState(false));
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.signInFormState);
        actions.resetSignInFormState();
    }

    updateLastLogInUserDetails(nextProps) {
        if (isNullOrUndefined(nextProps)) return;

        const { actions, signInFormData } = nextProps;

        if (isNullOrUndefined(actions) || isNullOrUndefined(signInFormData)) return;

        const { lastLoggedInDataCallBackUrl } = signInFormData;

        const { lastLoginDate, lastLoginPlatform, lastLoginDevice } = signInFormHelpers.getLastLogInData();

        actions.updateUserSignInDetails({
            lastLoginDate,
            lastLoginPlatform,
            lastLoginDevice,
            callBackUrl: lastLoggedInDataCallBackUrl
        });
    }

    handleSignInSuccess(cognitUser, nextProps) {
        const { onSignInSuccess, signInSuccessFormData, upgradeToOneClubFormData } = nextProps;
        const website = getWebsiteDomain();

        if (!hasValue(upgradeToOneClubFormData) && website === domainConstants.theOpen) {
            this.loadSSOUpgradeToOneClubFormData();
        }

        this.setState(formStateHelpers.updateProcessingState(false), () => {
            const redirectToAddress = getParameterByName(QueryConstants.REDIRECT_TO);
            const showPopup = getParameterByName(QueryConstants.SHOW_POPUP);

            const isOneClub = cognitUser.attributes['custom:Membership'].includes(MembershipTypes.OneClub);
            const optIns = JSON.parse(cognitUser.attributes['custom:OptIns']);
            userService.setTOCHUserMembershipsInLocalStorage(JSON.stringify(cognitUser.attributes['custom:Membership']));
            userService.setDataInLocalStorage(CookieNames.TOCH_USER_EMAIL, cognitUser.attributes.email);
            userService.setDataInLocalStorage(USER_ID, cognitUser.attributes.sub);

            const ticketingAccountId = cognitUser.attributes['custom:TicketingAccountId'];

            if (ticketingAccountId) {
                userService.setDataInLocalStorage(SECUTIX_CONTACT_ID, ticketingAccountId);
            }

            if (this.state.gtmTrigger === false) {
                this.state.gtmTrigger = true;
                gtm.push('Sign In', 'Sign in Success', window.location.href);
            }

            if (!isEmpty(redirectToAddress)) {
                redirectTo(redirectToAddress);
                return;
            }

            if (isOneClub && website === domainConstants.theOpen) {
                //check if should render upgrade to One Club account
                if (hasValue(upgradeToOneClubFormData)) {
                    const currentUser = upgradeToOneClubFormData.currentUser;
                    const hasOneClubRequiredFields = upgradeFormHelper.hasOneClubRequiredFields(currentUser, optIns);
                    if (!hasOneClubRequiredFields) {
                        onSignInSuccess(upgradeToOneClubFormData, ssoFormTypes.UpgradeToOneClubAccountFromDefault);
                    } else {
                        reloadPage();
                    }
                }
            } else {
                const hasAgreeToPrivacyPolicyChecked = signInFormHelpers.hasAgreeToPrivacyPolicyChecked(optIns);

                if (!hasAgreeToPrivacyPolicyChecked) {
                    onSignInSuccess(signInSuccessFormData, ssoFormTypes.SignInSuccess);
                    return;
                }

                if (isEmpty(showPopup)) {
                    reloadPage();
                    return;
                }

                reloadToBasePage();
            }
        });
    }

    getNextComponentToRender(optIns) {
        if (optIns.agreedToPrivacyPolicy === undefined || optIns.agreedToPrivacyPolicy === false) return true;

        return false;
    }

    handleSubmit(event) {
        event.preventDefault();
        const { signInFormData } = this.props;
        this.setState(formStateHelpers.handleFormValidation(signInFormData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (!this.state.formHasErrors) {
            this.setState(formStateHelpers.updateProcessingState(true), this.submitSignInData);
        }
    }

    submitSignInData() {
        const { actions, signInFormData } = this.props;
        const { actionSuccessText } = signInFormData;
        const {
            userName,
            emailAddress,
            password
        } = this.state;
        const { maxIdleTimeInSeconds } = signInFormData;

        actions.signInUser({
            userName,
            emailAddress,
            password,
            actionSuccessText,
            maxIdleTimeInSeconds
        });
    }

    displayForm() {
        const {
            onForgotPassword,
            onRegister,
            signInFormData,
            isSignInSuccessful,
            signInMessages
        } = this.props;

        if (isEmpty(signInFormData)) {
            return null;
        }

        return (<Fragment>
            <SSOFormHeader
                headerTitle={formMessageConstants.signIn}
                linkCallBackUrl={onRegister}
                headerMessage={formMessageConstants.haventGotAnAccount}
                headerLinkText={formMessageConstants.registerHere}
            ></SSOFormHeader>
            <form onSubmit={this.handleSubmit}>
                <FormMessage
                    isSuccessMessage={isSignInSuccessful}
                    messages={signInMessages}></FormMessage>
                {this.displaySignInForm()}
                <SSOFormFooter
                    footerButtonText={formMessageConstants.signIn}
                    onSubmit={this.handleSubmit}
                    linkCallBackUrl={onForgotPassword}
                    footerLinkText={formMessageConstants.forgottenPassword}
                ></SSOFormFooter>
            </form>
        </Fragment>);
    }

    displaySignInForm() {
        const { signInFormData } = this.props;
        return FormBuilder({
            formData: signInFormData,
            formReferences: this.formReferences,
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleFieldValidState: (fieldName) => { const { errors } = this.state; return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors); },
        });
    }

    render() {
        const { loading } = this.props;
        const { isProcessing } = this.state;

        return (
            <div ref={this.formReference} className='modal__content form-container'>
                <div className='auto-ph-md auto-p-md constrain-tablet ff-founders fs-14'>
                    <br />
                    {isProcessing || loading ? <FormSpinner>/</FormSpinner> : null}
                    {this.displayForm()}
                </div>
            </div>
        );
    }
}

SignInForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    onForgotPassword: PropTypes.func.isRequired,
    onRegister: PropTypes.func.isRequired,
    onNewPasswordRequired: PropTypes.func.isRequired,
    onSignInSuccess: PropTypes.func.isRequired,
    signInFormData: PropTypes.object,
    signInSuccessFormData: PropTypes.object
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        signInFormData: state.signInForm.signInFormData,
        isSignInSuccessful: state.signInForm.isSignInSuccessful,
        isUserLastLogInDataUpdated: state.signInForm.isUserLastLogInDataUpdated,
        userLastLogInDataErrorMessages: state.signInForm.userLastLogInDataErrorMessages,
        isNewPasswordRequired: state.signInForm.isNewPasswordRequired,
        cognitoUser: state.signInForm.cognitoUser,
        signInMessages: state.signInForm.signInMessages,
        signInSuccessFormData: state.signInForm.signInSuccessFormData,
        upgradeToOneClubFormData: state.upgradeAccountForm.upgradeToOneClubFormData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            updateUserSignInDetails: bindActionCreators(signInFormActions.updateUserSignInDetails, dispatch),
            loadSSOSignInFormData: bindActionCreators(signInFormActions.loadSSOSignInFormData, dispatch),
            signInUser: bindActionCreators(signInFormActions.signInUser, dispatch),
            resetSignInFormState: bindActionCreators(signInFormActions.resetSignInFormState, dispatch),
            loadSSOSignInSuccessFormData: bindActionCreators(signInFormActions.loadSSOSignInSuccessFormData, dispatch),
            loadSSOUpgradeToOneClubFormData: bindActionCreators(upgradeAccountFormActions.loadSSOUpgradeToOneClubFormData, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SignInForm);
